export const exportFieldsMapping = {
  patents: ["pn", "title", "publication_date", "source"],
  devices: ["mpn", "title", "brand_name", "category_name", "standards"],
  licensing: ["segment", "vertical", "applications", "companies"],
};
